module.exports = __webpack_public_path__ + "img/Platform_Gradients-2.4b9ccfc6.jpg";